/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Preview_Roadmap_TitleInputs */

const en_mk_preview_roadmap_title = /** @type {(inputs: Mk_Preview_Roadmap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the steps and how they connect.`)
};

const id_mk_preview_roadmap_title = /** @type {(inputs: Mk_Preview_Roadmap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat langkah dan keterkaitannya.`)
};

/**
* | output |
* | --- |
* | "See the steps and how they connect." |
*
* @param {Mk_Preview_Roadmap_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_preview_roadmap_title = /** @type {((inputs?: Mk_Preview_Roadmap_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Preview_Roadmap_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_preview_roadmap_title(inputs)
	return en_mk_preview_roadmap_title(inputs)
});